import { render, staticRenderFns } from "./PopupRulesAndConditions.vue?vue&type=template&id=fd739e06&"
import script from "./PopupRulesAndConditions.vue?vue&type=script&lang=js&"
export * from "./PopupRulesAndConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModalWindow: require('/builds/2oYM8JSf/1/mcp/sk-soutez-2022/frontend/components/ModalWindow.vue').default})
